
/* injects from baggage-loader */

'use strict';

import TermsOfUseComponent from './terms-of-use.component';

const TermsOfUsePageModule = angular.module('terms-of-use-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('terms-of-use', {
        url: '/legal/terms-of-use',
        component: 'termsOfUse',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('termsOfUse', new TermsOfUseComponent());

export default TermsOfUsePageModule;



// WEBPACK FOOTER //
// ./src/app/pages/legal/terms-of-use/terms-of-use.module.js